// Close the dropdown if the user clicks outside of it
window.onclick = function (event) {
    if ( event.target.parentNode && !event.target.parentNode.matches('.dropdown') && !event.target.parentNode.matches('.dropdown-toggle') ) {
        var dropdowns = document.getElementsByClassName("dp-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            if (openDropdown.classList.contains('show')) {
                openDropdown.classList.remove('show');
            }
        }
    }
}



// WEBPACK FOOTER //
// ./public/utils/dropdown.js